import React, { useEffect, useState } from "react";
import * as LogRocket from "logrocket";
import { useAuth0 } from "@auth0/auth0-react";

const LOGROCKET_APP_ID = process.env.LOGROCKET_APP_ID;

export default function LogRocketComponent() {
  if (LOGROCKET_APP_ID) {
    const [recordingURL, setRecordingURL] = useState<string>();
    const { isLoading, user } = useAuth0();

    useEffect(() => {
      let stillSet = true;
      LogRocket.getSessionURL(url => {
        if (stillSet) {
          setRecordingURL(url);
          console.log("LogRocket recording started at URL", url);
        }
      });
      return () => {
        stillSet = false;
      };
    }, [setRecordingURL]);

    useEffect(() => {
      if (!isLoading && user) {
        LogRocket.identify(user.sub, user);
      }
    }, [isLoading, user]);
    return (
      <div
        id="#LogRocket_recordingURL"
        data-recording-url={recordingURL}
        style={{ display: "none" }}
      />
    );
  } else {
    console.log("LogRocket disabled");
  }
  return <></>;
}
